<template>
  <div>
    <titulo-analise-retroativa-contas-pagar />
    <b-row>
      <b-col cols="12" md="3">
        <input-date-only-btn
          ref="dataRetroativa"
          v-model="filtro.dataRetroativa"
          :label="$t('FINANCEIRO.DATA_RETROATIVA')"
          required
        />
      </b-col>

      <b-col cols="12" md="4">
        <input-select-search
          ref="planoContaId"
          v-model="filtro.planoContaId"
          :label="$t('CONTABIL.CONTA_CONTABIL')"
          :options="opcoes.planosConta"
        />
      </b-col>

      <b-col cols="12" md="3">
        <b-button
          class="mt-3 botao-acao-filtro w-100"
          variant="info"
          @click="gerarRelatorioAnaliseRetroativa"
          v-if="podeVisualizar"
        >
          {{ $t('GERAL.IMPRIMIR_RELATORIO') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import pdf from '@/common/utils/pdf';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import TituloService from '@/common/services/titulo/titulo.service';
import PlanoContaService from '@/common/services/plano-conta/plano-conta.service.js';

// Components:
import { InputDateOnlyBtn, InputSelectSearch } from '@/components/inputs';
import TituloAnaliseRetroativaContasPagar from '@/views/financeiro/relatorios/RelatorioAnaliseRetroativaContasPagar/TituloAnaliseRetroativaContasPagar';

export default {
  mixins: [Permissoes],
  components: {
    InputDateOnlyBtn,
    InputSelectSearch,
    TituloAnaliseRetroativaContasPagar,
  },

  template: {},
  data() {
    return {
      filtro: {
        dataRetroativa: '',
        planoContaId: '',
      },
      opcoes: {
        planosConta: [],
      },
    };
  },
  mounted() {
    this.getPlanoContas();
  },
  methods: {
    getPlanoContas() {
      this.$store.dispatch(START_LOADING);
      PlanoContaService.obterTodos()
        .then(({ data }) => {
          this.opcoes.planosConta = data
            .sort((a, b) => a.codigo - b.codigo)
            .map((row) => ({
              text: `${row.codigo} - ${row.descricao} `,
              value: row.id,
            }));
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    gerarRelatorioAnaliseRetroativa() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      TituloService.gerarRelatorioAnaliseRetroativa(this.filtro)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>

<style>
.ajuste-fino-btn {
  margin-top: 27px;
}
</style>
